import React from 'react';
import { useDispatch } from 'react-redux';
import { setActiveTab } from '@/finsight/application/actions/bonds/metadata/actions';
import metadataSelectors from '@/finsight/application/actions/bonds/metadata/selectors';
import useReduxSelector from '@/Framework/hooks/useReduxSelector';
import { useInventoryTableContext } from '@/finsight/application/Bonds/InventoryTableContext';
import { useBwicTableContext } from '@/finsight/application/Bonds/BwicTableContext';
import BondTypes from './BondTypes';

const stateSelector = (state) => ({
  activeTab: metadataSelectors.getActiveTab(state),
});

const BondTypesContainer = (props) => {
  const dispatch = useDispatch();
  const { activeTab } = useReduxSelector(stateSelector);
  const {
    inventoriesData: { inventories: { totalCount: inventoriesTotalCount } },
  } = useInventoryTableContext();
  const {
    bwicsData: { bwics: { totalCount: bwicsTotalCount } },
  } = useBwicTableContext();

  return (
    <BondTypes
      { ...props }
      isInventoryEmpty={ !inventoriesTotalCount }
      isBwicEmpty={ !bwicsTotalCount }
      activeTab={ activeTab }
      setActiveTab={ (tab: string) => dispatch(setActiveTab(tab)) }
    />
  );
};

export default BondTypesContainer;
